import { Chart } from 'devextreme-react';
import { ArgumentAxis, CommonSeriesSettings, Label, Legend, Series, Tooltip, ValueAxis } from 'devextreme-react/chart';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useEffect, useState } from 'react';
import reportService from '@/projects/platform/services/report-service';

export default function SalesQuantityTrend(props: any) {
    var params: string;
    const { retailerId, startDate, endDate } = props;
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);

    function filter() {
        params = '';
        for (const key of Object.keys(props)) {
            if (props[key]) {
                params += `${key}=${props[key]}&`;
            }
        }
        params = params.slice(0, -1);
    }
    function customizeTooltip(pointInfo: any) {
        return {
            html: `<div><div class="tooltip-header">${pointInfo.argumentText
                }</div><div class="tooltip-body"><div class="series-name"><span class='top-series-name'>${pointInfo.points[0].seriesName
                }</span>: </div><div class="value-text"><span class='top-series-value'>${pointInfo.points[0].valueText
                }</span></div><div class="series-name"><span class='bottom-series-name'>${pointInfo.points[1].seriesName
                }</span>: </div><div class="value-text"><span class='bottom-series-value'>${pointInfo.points[1].valueText
                }</span>% </div></div></div>`,
        };
    }

    function customizePercentageText({ valueText }: any) {
        return `${valueText}`;
    }
    useEffect(() => {
        setLoading(true);
        filter();
        reportService.getSalesQuantityTrend(params)
            .then((response) => {
                setDataSource(response.data.searchResult);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                throw new Error('Data Loading Error');
            });
    }, [retailerId, startDate, endDate]);

    return (
        <>
            <LoadIndicator visible={loading} />
            <Chart
                title="Sales Quantity Trend"
                dataSource={dataSource}
                palette="Harmony Light"
                id="chart"
            >
                <CommonSeriesSettings argumentField="month" />
                <Series
                    name="Satış Adedi"
                    valueField="salesQuantity"
                    axis="frequency"
                    type="bar"
                    color="#fac29a"
                />
                <Series
                    name="Satış Miktarı"
                    valueField="salesAmount"
                    axis="percentage"
                    type="spline"
                    color="#6b71c3"
                />

                <ArgumentAxis>
                    <Label overlappingBehavior="stagger" />
                </ArgumentAxis>

                <ValueAxis
                    name="frequency"
                    position="left"
                    tickInterval={300}
                />
                <ValueAxis
                    name="percentage"
                    position="right"
                    tickInterval={20}
                    showZero={true}
                    valueMarginsEnabled={false}
                >
                    <Label customizeText={customizePercentageText} />
                </ValueAxis>

                <Tooltip
                    enabled={true}
                    shared={true}
                    customizeTooltip={customizeTooltip}
                />

                <Legend
                    verticalAlignment="top"
                    horizontalAlignment="center"
                />
            </Chart>
        </>
    );
}
